import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { BayclubsAlertService } from '@bayclubs/alert';
import { ErrorTranslationService, FormService } from '@bayclubs/utils';

import { campsenum } from '../../../../../../../../models/enums.generated';
import { camps } from '../../../../../../../../models/models.generated';
import { SessionManagementApiService } from '../../../../../../../../services/api/session-management-api.service';
import { CampsEnumTranslationService } from '../../../../../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../../../../../camp-details-form-state-service';

@Component({
    selector: 'app-session-basic-info-edit',
    templateUrl: './session-basic-info-edit.component.html',
    styleUrls: ['./session-basic-info-edit.component.scss'],
    standalone: false,
})
export class SessionsBasicInfoEditComponent implements OnInit {
    @Input() context: camps.CampDefinitionCreationContext;

    @Input() public form: UntypedFormGroup;

    @Input() public isNew: boolean = false;

    @Output() canceled: EventEmitter<UntypedFormGroup> = new EventEmitter();

    public ageChange: boolean = false;

    constructor(
        private state: CampsDetailsFormStateService,
        private enumTranslator: CampsEnumTranslationService,
        private api: SessionManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {
        this.form.get('ageRangeFromInMonths').valueChanges.subscribe((value) => {
            this.form.get('ageRangeFromInMonthsEffective').setValue(value);
        });
        this.form.get('ageRangeToInMonths').valueChanges.subscribe((value) => {
            if (value % 12 === 0) {
                value = value + 12;
            }

            this.form.get('ageRangeToInMonthsEffective').setValue(value);
        });

        this.form.get('timeFromInMinutes').valueChanges.subscribe((value: number) => {
            if (value >= this.form.value.timeToInMinutes) {
                this.form.controls.timeToInMinutes.setValue(Math.min(value + 15, 1440));
            }
        });

        this.form.get('timeToInMinutes').valueChanges.subscribe((value: number) => {
            if (value <= this.form.value.timeFromInMinutes) {
                this.form.controls.timeFromInMinutes.setValue(Math.max(value - 15, 0));
            }
        });
    }

    public get sessionDaysForm(): UntypedFormGroup {
        return this.form.controls['sessionDays'] as UntypedFormGroup;
    }

    public save() {
        var request = this.getRequest();

        this.api.save(request).subscribe((x) => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.state.finishEdit(this.form);
                this.state.sessionChanged.emit(x.value.id);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }

    public getRequest() {
        this.setPrice();

        var request = <camps.SessionSaveRequest>{
            campId: this.form.get('campId').value,
            sessionId: this.form.get('id').value,
            ageInMonthFrom: this.form.get('ageRangeFromInMonths').value,
            ageInMonthTo: this.form.get('ageRangeToInMonths').value,
            ageInMonthFromFilter: this.form.get('ageRangeFromInMonthsEffective').value,
            ageInMonthToFilter: this.form.get('ageRangeToInMonthsEffective').value,
            name: this.form.get('name').value,
            description: this.form.get('description').value,
            clubId: this.form.get('clubId').value,
            maxCapacity: this.form.get('capacity').value,
            timeRangeVariant: this.form.get('timeRangeVariant').value,
            mSRP: this.form.get('basePrice').value,
            timeFrom: this.form.get('timeFromInMinutes').value,
            timeTo: this.form.get('timeToInMinutes').value,
            sessionDays: this.form.get('sessionDays.daysDates').value,
            allowCustomVariantSelection: this.form.get('allowCustomVariantSelection').value,
            allowCampCreditPointsUsage: this.form.get('allowCampCreditPointsUsage').value,
            contactEmail: this.form.get('contactEmail').value,
            contactPhone: this.form.get('contactPhone').value,
            contactWorkingHours: this.form.get('contactWorkingHours').value,
        };

        return request;
    }

    public cancel() {
        this.state.finishEdit(this.form, false);
        // this.canceled.emit(this.form);
    }

    public onClubChanged(club: camps.ClubModel) {
        console.log(club);
        this.form.controls['clubId'].setValue(club.id);
        this.form.controls['clubName'].setValue(club.name);
    }

    private setPrice() {
        var price = FormService.getAmountFromCurrencyMask(this.form.controls['basePrice'].value);
        this.form.controls['basePrice'].setValue(price);
    }

    public translateVariant(value: campsenum.TimeRangeVariantType) {
        return this.enumTranslator.timeVariant(value);
    }

    public changeVariant(variant: campsenum.TimeRangeVariantType) {
        this.form.controls['timeRangeVariant'].setValue(variant);
    }

    public unlimitedClicked(value) {
        if (value) {
            this.form.controls['capacity'].setValue(null);
        } else {
            this.form.controls['capacity'].setValue(20);
        }
    }

    public isFormValid() {
        return FormService.isFormValid(this.form);
    }

    public toggleAgeChange() {
        this.ageChange = !this.ageChange;
    }

    public onCustomVariantAllowedChange($event) {
        this.form.controls.allowCustomVariantSelection.setValue($event);
    }

    public onCreditPointsUsageAllowedChange($event) {
        this.form.controls.allowCampCreditPointsUsage.setValue($event);
    }
}
